const doesWindowExist = () => {
  return typeof window !== 'undefined';
};

const getEnvVariableFromConfig = (name: string) => {
  if (doesWindowExist()) {
    return window?.configs?.[name] || process.env?.[name];
  }
  return process.env?.[name];
};

export const getRequiredEnvValue = (name: string): string => {
  const value = getEnvVariableFromConfig(name);
  if (!value && !doesWindowExist()) {
    // throw error in node env
    throw new Error(`[player-config] Required env var "${name}" is not defined`);
  }
  return value;
};

const MANDATORY_ENV_VARIABLES = ['VISION_URL', 'CLOUDFRONT_STATIC_ASSET_URL', 'VUE_APP_VID_CDN_URL'];

MANDATORY_ENV_VARIABLES.forEach(envKey => getRequiredEnvValue(envKey));
